import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { useDebounce } from "../../../../hooks/useDebounce";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Badge from "../../../../components/elements/Badge";
import { getPaginationRange, handleFilterChange } from "../../../../helpers";
import Table from "../../../../components/elements/table/Table";
import Button from "../../../../components/form/Button";
import DeleteModal from "../../../../components/common/DeleteModal";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import TableControls from "../../../../components/elements/TableControls";
import ActionBar from "../../../../components/elements/ActionBar";
import { status_filter } from "../../../../components/constant/constant";
import { quizDelete, quizList, quizStatusChange } from "../../../../services/quizService";

const Quiz = ({ artists = null }) => {
  setTitle("Quiz");
  const navigate = useNavigate();
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 100,
    page: 1,
    sortQuery: "ordering",
  });

  const [selectedFilter, setSelectedFilter] = useState(null);
  const [selectFilterItem, setSelectFilterItem] = useState([]);

  const { data, error, isLoading, updateData, isFetching, refetch } = useQuery({
    queryKey: ["quiz", filters, search, selectFilterItem],
    queryFn: async () => {
      const res = await quizList({
        ...filters,
        sectionType : "quiz",
        ...(selectedFilter === "status" && { status: selectFilterItem?.value }),
        // ...(selectedFilter === "dateRange" && {
          // startDate: dayjs(selectFilterItem?.value?.startDate).format("YYYY-MM-DD"),
          // endDate: dayjs(selectFilterItem?.value?.endDate).format("YYYY-MM-DD"),
        // }),
        ...(search && { keyword: search }),
        ...(artists && { user: artists }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   Blog status change handler =================>
  const { mutate: statusChangeHandler, isPending: statusChangeInPending } = useMutation({
    mutationFn: async ({ id, status }) => {
      queryClient.setQueryData(["quiz", filters, search, selectFilterItem], (state) => {
        if (!state) return;

        const updatedData = state?.data?.map((item) =>
          item?._id === id
            ? {
                ...item,
                status: item.status === "active" ? "inactive" : "active",
              }
            : item
        );

        return { ...state, data: updatedData };
      });
      const res = await quizStatusChange({ ids: [id], status });

      return { res, payload: { id, status } };
    },

    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        toast.success("Quiz status change successfully.");
      } else {
        queryClient.setQueryData(["quiz", filters, search, selectFilterItem], (state) => {
          if (!state) return;

          const revertedData = state?.data?.map((item) =>
            item?._id === payload.id
              ? {
                  ...item,
                  status: item.status === "active" ? "inactive" : "active",
                }
              : item
          );

          return { ...state, data: revertedData };
        });

        toast.error(res?.message || "Failed to update status.");
      }
    },

    onError: (error) => {
      toast.error(error?.message || "Something went wrong while updating status.");
      console.error("Status update error:", error);
    },
  });

  const tableHeadData = [
    // {
    //   _id: 1,
    //   name: "Image",
    //   align: "left",
    // },
    {
      _id: 2,
      name: "Question",
      align: "left",
      // isSort: true,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     setFilters((pre) => ({ ...pre, sortQuery: "-title" }));
      //   } else {
      //     setFilters((pre) => ({ ...pre, sortQuery: "title" }));
      //   }
      // },
    },
    {
      _id: 3,
      name: "Options",
      align: "left",
      // isSort: true,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     setFilters((pre) => ({ ...pre, sortQuery: "-title" }));
      //   } else {
      //     setFilters((pre) => ({ ...pre, sortQuery: "title" }));
      //   }
      // },
    },
    // {
    //   _id: 3,
    //   name: "Categories",
    //   align: "left",
    //   isSearchFilter: true,
    //   onSearchFilter: (val) => {
    //     console.log(val, "select value");
    //     if (val?.length > 0) {
    //       setSelectedSearchData({
    //         category: val,
    //       });
    //     } else {
    //       setSelectedSearchData({
    //         category: [],
    //       });
    //     }
    //   },
    //   isOption: "select",
    //   searchData:
    //     categorieslist?.data?.map((it) => ({
    //       name: it?.title,
    //       value: it?._id,
    //     })) || [],
    //   keywordSearch: (val) => {
    //     setCategoryKeyWord(val);
    //   },
    // },
    {
      _id: 30,
      name: "Points",
      align: "left",
    },
    {
      _id: 10,
      name: "Artist",
      align: "left",
    },
    {
      _id: 4,
      name: "Publish Date",
      align: "left",
      // isSort: true,
      // onSort: (val) => {
      //   if (val === "DESC") {
      //     setFilters((pre) => ({ ...pre, sortQuery: "-createdAt" }));
      //   } else {
      //     setFilters((pre) => ({ ...pre, sortQuery: "createdAt" }));
      //   }
      // },
      // isSearchFilter: true,
      // onSearchFilter: (val) => {
      //   console.log(val, "range valueee");
      // },
      // isOption: "range-picker",
    },
    {
      _id: 5,
      name: "Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      onFilter: (val) => {
        if (val?.length > 0 && val?.length === 1) {
          setFilters((pre) => ({
            ...pre,
            status: val?.map((item) => item?.value),
            page: 1,
          }));
        } else {
          setFilters((pre) => {
            delete pre?.status;
            return { ...pre };
          });
        }
      },
      filterData: status_filter || [],
    },
    {
      _id: 6,
      name: "Action",
      align: "left",
    },
  ];
  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        // {
        //   _id: 1,
        //   type: "image",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   image: item?.coverMedia?.url,
        // },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <div dangerouslySetInnerHTML={{ __html: item?.label?.text || "-" }}></div> || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: <div dangerouslySetInnerHTML={{ __html: item?.options.length || "-" }}></div> || "-",
        },
        // {
        //   _id: 3,
        //   type: "text",
        //   align: "left",
        //   cellClass: "!min-w-[100px]",
        //   data: (
        //     <>
        //       {item?.categoryDetails?.length > 1 ? (
        //         <Tooltip
        //           position="bottom"
        //           className=""
        //           message={
        //             <div className="text-[12px] whitespace-pre-wrap max-w-xs flex flex-wrap gap-1">
        //               {item.categoryDetails.map((it, ind) => (
        //                 <Badge key={ind} customColor={tagColors[ind % tagColors.length]} label={it?.title} className="!rounded-full !h-6" />
        //               ))}
        //             </div>
        //           }
        //           messageClass="!bg-gradient-to-br !from-slate-600 !via-slate-500 !to-slate-500 !p-2 !rounded-lg !shadow-md border !border-gray-200"
        //         >
        //           <div className="flex items-center gap-2">
        //             <Badge customColor={tagColors[0]} label={item.categoryDetails[0]?.title} className="!rounded-full !h-6" />
        //             <span className="bg-gray-100 text-gray-800 font-bold text-xs px-2 py-1 rounded-full border border-gray-300">
        //               +{item.categoryDetails.length - 1} more
        //             </span>
        //           </div>
        //         </Tooltip>
        //       ) : (
        //         <div className="flex items-center gap-2">
        //           {item?.categoryDetails?.length === 1 ? (
        //             <Badge customColor={tagColors[0]} label={item?.categoryDetails[0]?.content?.[userLang]?.title} className="!rounded-full !h-6" />
        //           ) : (
        //             <span className="text-gray-500 text-sm text-center">-</span>
        //           )}
        //         </div>
        //       )}
        //     </>
        //   ),
        // },
        {
          _id: 30,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.points || "-",
        },
        {
          _id: 10,
          type: "imageWithText",
          align: "left",
          cellClass: "!min-w-[100px]",
          image: item?.userInfo?.image?.url,
          data:
            item?.userInfo?.firstName && item?.userInfo?.lastName
              ? `${item?.userInfo?.firstName} ${item?.userInfo?.lastName}`
              : "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.schedule?.startDate ? dayjs(item?.schedule?.startDate).format("DD MMM, YYYY") : "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div
              className="flex gap-2 items-center cursor-pointer"
              onClick={() => {
                statusChangeHandler({
                  id: item?._id,
                  status: item?.status === "active" ? "inactive" : "active",
                });
              }}
            >
              <Badge type={item?.status === "active" ? "success" : "danger"} label={item?.status === "active" ? "Active" : "Inactive"} />
            </div>
          ),
        },
        {
          _id: 6,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                navigate(`/admin/manage-quiz/-${item?.key}`);
              },
              standout: false,
            },

            {
              _id: 2,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  //   Blog delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await quizDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        setSelectedItems([]);
        queryClient.setQueryData(["quiz", filters, search, selectFilterItem], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || [])?.filter((item) => !payload?.includes(item?._id));
            return { ...state, data: stateData };
          }
        });

        queryClient.invalidateQueries(["quiz", filters, search, selectFilterItem]);
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  function actionHandler(val) {
    switch (val) {
      case "blogDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }
  const options = [
    {
      id: "blogDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "Blog Delete",
    },
  ];

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        {
          !artists && <div className="font-bold text-lg xl:text-3xl text-primary mb-8">
          Quiz Management
        </div>
        }
        
        <div className="flex items-center gap-3">
          <TableControls
            limit={artists?10:filters?.limit}
            totalDocs={data?.metadata?.totalDocs}
            onLimitChange={(val) => handleFilterChange("limit", val, setFilters)}
            onSearch={(val) => {
              setKeyword(val);
              handleFilterChange("page", 1, setFilters);
            }}
          />
          {selectedItems?.length > 0 && (
            <div className="flex items-center gap-2">
              <ActionBar options={options} onChange={actionHandler} />
              <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                {selectedItems?.length} Selected
                <button onClick={() => setSelectedItems([])} type="button" className="cursor-pointer">
                  <i className="fa-fw fa-light fa-xmark"></i>
                </button>
              </span>
            </div>
          )}
          <div className="relative ml-auto">
            {artists ? (
              <div></div>
            ) : (
              <Button buttonIcon={"fa-regular fa-plus"} buttonLabel={"Create Quiz"} buttonFunction={() => navigate("/admin/manage-quiz")} />
            )}
          </div>
        </div>
      </div>

      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        totalDataCount={data?.metadata?.totalDocs}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        // handleOrdering={(newData, oldData) => {
        //   postOrderingHandler(newData, oldData);
        // }}
        originalData={[...(data?.data || [])]}
        setOriginalData={(data) =>
          queryClient.setQueryData(["blog", filters, search], (state) => {
            if (state) {
              return { ...state, data: data };
            }
          })
        }
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectable
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
        showingData={getPaginationRange(filters?.page, filters?.limit, data?.metadata?.totalDocs)}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Quiz;
